import { faSlidersH } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { format } from "date-fns/format";
import React from "react";
import { useTranslation } from "react-i18next";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistorySettingChangeItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";

export type ObjectHistorySettingChangeItemProps = {
    item: IObjectHistorySettingChangeItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistorySettingChangeItem({ item, contextObject }: ObjectHistorySettingChangeItemProps) {
    const { t } = useTranslation();

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<FontAwesomeIcon icon={faSlidersH} size="2x" />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.userName ?? ""}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                <Typography variant="body2" noWrap={false}>
                    {item.oldValue ? 
                    t("objectHistory.settingChangeItem.changeText", {
                        tagName: item.tagName,
                        oldValue: item.oldValue,
                        newValue: item.newValue
                    }) : 
                    t("objectHistory.settingChangeItem.newText", {
                        tagName: item.tagName,
                        newValue: item.newValue
                    })  
                    }
                </Typography>
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}
